<template>
  <b-form-input @click="popupCk" v-model="fileUrl" :id="$props.id"/>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ref} from '@vue/composition-api'
import {
  BFormInput, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BCardCode,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  model: {
    prop: 'title',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  setup(props, {emit}) {
    let fileUrl = ref(props.title)
    console.log(fileUrl);
    let popupCk = () => {
      window.CKFinder.popup({
        chooseFiles: true,
        width: 800,
        height: 600,
        onInit: function (finder) {

          console.log(finder)
          try {
            finder.Backbone.$.ajaxSetup({
              headers: {'custom-header': 'some value'}
            })
          } catch (e) {
            console.log(e);
          }

          finder.on('files:choose', function (evt) {
            try {
              let file = evt.data.files.first();
              let url = file.getUrl()
              console.log(url);
              fileUrl.value = url;
              emit('change', url)
            } catch (e) {
              console.log(e);
            }
          });

          finder.on('command:before', function (evt) {
            try {
              console.log(evt.data.params)

              // let file = evt.data.files.first();
              // let url = file.getUrl()
              // console.log(url);
              // fileUrl.value = url;
              // emit('change', url)
            } catch (e) {
              console.log(e);
            }
          });


          finder.on('file:choose:resizedImage', function (evt) {

          });
        }
      });
    }
    return {
      fileUrl,

      popupCk,
    }
  },
}
</script>
